<div class="w-full">
  Native - A Race is considered "native" to a star system when:<br />
  <ul>
    <li class="ml-14 ism-white">That race has a population present</li>
    <li class="ml-14 ism-white">It is a trade endpoint with another race</li>
    <li class="ml-14 ism-white">It is on a path between populations and/or a trade endpoint</li>
  </ul>
</div>

<div id="_stateComms-CENTER_" class="my-2 px-2 text-1.25 ism-white w-3/5 flex flex-col border overlay-dark-30">
  <!-- @if(informationRacesNonComm.length>0){ -->
  @for (informationRace of informationRacesNonComm; track informationRace._id) {
    <!-- @let formName = "form_"+informationRace._id; -->
    <div class="w-full flex flex-col">
      <!-- //ANCHOR - Comms-N-Progress -->
      Communication in process - What to do if another contact occurs:
      <div class="overlay-dark-80">
        <hr class="border-yellow-400" />
        <div class="flex items-center">
          <div class="m-2 ism-green">Star System #{{ starSystemHash[informationRace.aboutRace.starSystemId].number }}</div>
          &nbsp; / &nbsp;
          <div class="m-2 ism-gold">{{ informationRace.aboutRace.name }} ({{ informationRace.aboutRace.techLevel > 0 ? "High Tech" : "Low Tech" }})</div>
        </div>
        <div class="flex">
          <table class="w-1/2">
            <tr class="data">
              <th><label># of Attempts:</label></th>
              <td>{{ informationRace.communicationAttemptCount || 0 }}</td>
            </tr>
            <tr>
              <th><label class="whitespace-nowrap">Communication State:</label></th>
              <td>{{ informationRace.communicationState }}</td>
            </tr>
            <tr>
              <th><label>Process:</label></th>
              <td>
                <select ng-model="informationRace.communicationInstruction" class="ism-black">
                  <option value="Continue">Continue</option>
                  <option value="Pause">Suspend</option>
                </select>
              </td>
            </tr>
          </table>

          <table class="w-1/2">
            <tr>
              <th><label>Native:</label></th>
              <td>
                <select ng-model="informationRace.reactionOrderNative" class="ism-black" ng-options="contactInstruction for contactInstruction in responsesPostFirstContact"></select>
                <br />
              </td>
            </tr>
            <tr>
              <th><label>Non-Native:</label></th>
              <td>
                <select ng-model="informationRace.reactionOrderNonNative" class="ism-black" ng-options="contactInstruction for contactInstruction in responsesPostFirstContact"></select>
                <br />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <!-- <button class="mx-2 px-4 btn" type="button" (click)="saveNonComm(form_informationRacesNonComm)">Save</button> -->
    </div>
  }
  <!-- -->
  @empty {
    <div>No Communication in process</div>
  }
</div>
